module.exports = __webpack_public_path__ + "static/img/icon_fire.1d7f834a.svg";